<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <p>
        List of supported applications
      </p>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="app-list-container">
    @for (app of appList; track app) {
      <span class="name">{{ app.name }}</span>
      @if (app.androidUrl) {
        <div>
          <a target="_blank" [href]="app.androidUrl">
            <button mat-raised-button color="primary">
              Get for Android
              <mat-icon>open_in_new</mat-icon>
            </button>
          </a>
        </div>
      }
      @if (app.iosUrl) {
        <div>
          <a target="_blank" [href]="app.iosUrl">
            <button mat-raised-button color="primary">
              Get for iOS
              <mat-icon>open_in_new</mat-icon>
            </button>
          </a>
        </div>
      }
    }
  </div>
</mat-expansion-panel>
